<template>
    <meta charset="UTF-8">

    <div class="page">
        <div class="head-title">
            <div class="left">
                <ul class="breadcrumb">
                    <li>
                        <a href="#" class="active">{{ $t("Property") }}</a>
                    </li>
                    <li>-</li>
                    <li>
                        <router-link to="/property/allproperties" class="active">{{ $t("all") }} {{ $t("offer") }} {{
                            $t("price")
                            }}</router-link>
                    </li>
                </ul>
            </div>
        </div>

        <div class="main">
            <div class="head">
                  <div class="head1">
    <h3>{{ $t("offer") }} {{ $t("price") }}</h3>
    <div class="filter-container">
      <input type="text" :placeholder="$t('code')" v-model="filters.qid" />
      <input type="text" :placeholder="$t('name') + ' ' + $t('realty')" v-model="filters.propertyname" />
      <input type="text" :placeholder="$t('name') + ' ' + $t('renter')" v-model="filters.rentername" />
      <input type="text" :placeholder="$t('unit')" v-model="filters.unite" />
      <select v-model="filters.conttype">
        <option value=""> {{ $t('type') }} {{ $t('contract') }}</option>
        <option value="residential">{{ $t('residential') }}</option>
        <option value="commercial">{{ $t('commercial') }}</option>
      </select>
      <select v-model="filters.contduration">
        <option value="">{{ $t('payment') }}</option>
        <option value="1">{{ $t('monthly') }}</option>
        <option value="3">{{ $t('ربع سنوى') }}</option>
        <option value="6">{{ $t('نصف سنوى') }}</option>
        <option value="12">{{ $t('سنوى') }}</option>
      </select>
      <button class="search-btn" @click="applyFilters">{{ $t('search') }}</button>
    </div>
  </div>

                <div class="head2">
                    <button>
                        <router-link to="/property/createpriceoffer" class="btn-download">
                            <span class="text">
                                <i class="bi bi-clipboard-plus-fill"></i>
                                {{ $t("add") }} {{ $t("offer") }} {{ $t("price") }}</span>
                        </router-link>
                    </button>
                </div>
            </div>
            <div class="body">
                <!-- <router-link class="btn-download" v-for="x in property" :key="x" :to="link + x.pid">
              <div class="part">
                <div class="group">
                  <div style="text-align: center">{{ x.name }}</div>
                  <div style="font-size: small">
                    {{ $t("owner") }} : {{ x.ownername }}
                  </div>
                </div>
                <div class="group">
                  <img :src="this.url + x.pid + '-' + this.cnum + '.png'"
                    @error="$event.target.src = `${this.url}Default.png`" crossorigin="anonymous" />
                </div>
              </div>
            </router-link> -->

                <table class="table">
                    <thead>
                        <tr>
                            <th>{{ $t("code") }}</th>
                            <th>{{ $t("name") }} {{ $t("realty") }}</th>
                            <th>{{ $t("name") }} {{ $t("renter") }}</th>
                            <th>{{ $t("unit") }}</th>
                            <th>{{ $t("type") }} {{ $t("contract") }}</th>
                            <th>{{ $t("amount") }}</th>
                            <th>{{ $t("payment") }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="x in property" :key="x">
                            <th>
                                <router-link :to="link + x.qid">
                                    {{ x.qid }}
                                </router-link>
                            </th>
                            <th>
                                <router-link :to="link + x.qid">{{
                                    x.propertyname
                                    }}</router-link>
                            </th>
                            <th>
                                <router-link :to="link + x.qid">{{ x.rentername }}</router-link>
                            </th>
                            <td>{{ x.unite }}</td>
                            <td>{{ $t(x.conttype) }}</td>
                            <td>
                                {{
                                Number((x.contamount / 12) * x.contduration).toLocaleString()
                                }}
                            </td>
                            <td>
                                <span v-if="x.contduration == 1">شهرى</span>
                                <span v-if="x.contduration == 3">ربع سنوي</span>
                                <span v-if="x.contduration == 4">ثلث سنوى</span>
                                <span v-if="x.contduration == 6">نصف سنوى</span>
                                <span v-if="x.contduration == 12">سنويا</span>
                            </td>
                            <td>
                                <!-- Button trigger modal -->
                                <button type="button" data-bs-toggle="modal" style="width: 100%"
                                    :data-bs-target="'#exampleModal' + x.qid" @click="getdata(x)">
                                    <i class="bi bi-printer-fill"></i>
                                </button>

                                <!-- Modal -->
                                <div class="modal fade" :id="'exampleModal' + x.qid" tabindex="-1"
                                    aria-labelledby="exampleModalLabel" aria-hidden="true">
                                    <div class="modal-dialog modal-xl">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title" id="exampleModalLabel">
                                                    عرض سعر
                                                </h5>
                                            </div>
                                            <div class="modal-body" style="padding: 6%" :id="'main-' + x.qid">
                                                <div style="direction: rtl">
                                                    <!-- <div class="modhead">
                                <div class="part">
                                  عرض أسعار <br />
                                  Quote
                                </div>
                                <div class="logo">
                                  <img :src="this.url" crossorigin="anonymous" />
                                </div>
                              </div> -->
                                                    <br />
                                                    <br />
                                                    <br />

                                                    <div class="modhead">
                                                        <div class="part">
                                                            {{ $t("number") }} : {{ x.qid }} <br />
                                                            {{ $t("date") }} : {{ x.date }}
                                                        </div>
                                                    </div>
                                                    <div class="mixed-content" style="padding: 1%">
                                                        السادة : {{ x.rentername }} <br />
                                                        السلام عليكم ورحمة الله وبركاتة <br />
                                                        تحية طيبة وبعد ,,,, <br />
                                                        إشارة الى رغبتكم فى إيجار {{ unitetype }} -
                                                        {{ fixArabicTextWithNumbers(x.propertyname) }} - رقم {{ x.unite }}
                                                    </div>
                                                    <div style="padding: 1%; display: flex">
                                                        <div class="part" style="width: 10%">
                                                            {{ $t("notes") }}
                                                        </div>
                                                        <div class="part" style="width: 90%">
                                                            {{ fixArabicTextWithNumbers(x.notes) }}
                                                            <!-- {{ x.notes}} -->
                                                        </div>
                                                    </div>

                                                    <div style="padding: 2%">
                                                        <table class="table">
                                                            <thead>
                                                                <tr>
                                                                    <th>نوع العقار</th>
                                                                    <th>الاستخدام</th>
                                                                    <th>اجمالى المساحة</th>
                                                                    <th>سعر المتر المربع</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>{{ unitetype }}</td>
                                                                    <td>{{ $t(x.conttype) }}</td>
                                                                    <td>{{ unitspace }}</td>
                                                                    <td>{{ unitspacep }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div style="padding: 2%">
                                                        <table class="table">
                                                            <thead>
                                                                <tr>
                                                                    <th>{{ $t("details") }}</th>
                                                                    <th>{{ $t("amount") }}</th>
                                                                    <th>{{ $t("tax") }}</th>
                                                                    <th>{{ $t("total") }}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        القسط الاول لمده
                                                                        <span v-if="due == 1">شهر</span>
                                                                        <span v-if="due == 3">3 شهور</span>
                                                                        <span v-if="due == 4"> 4 شهور</span>
                                                                        <span v-if="due == 6"> 6 شهور</span>
                                                                        <span v-if="due == 12"> سنة</span>
                                                                    </td>
                                                                    <td>
                                                                        {{ Number(dueamount).toLocaleString() }}
                                                                    </td>
                                                                    <td>{{ Number(tax).toFixed(2) }}</td>
                                                                    <td>
                                                                        {{
                                                                        Number(
                                                                        (x.contamount / 12) * x.contduration
                                                                        ).toLocaleString()
                                                                        }}
                                                                    </td>
                                                                </tr>
                                                                <tr v-for="y in commission" :key="y">
                                                                    <td>{{ y.name }}</td>
                                                                    <td>
                                                                        {{ Number(y.comamount).toLocaleString() }}
                                                                    </td>
                                                                    <td>
                                                                        {{
                                                                        Number(
                                                                        (y.comamount * y.tax) / 100
                                                                        ).toFixed(2)
                                                                        }}
                                                                    </td>
                                                                    <td>
                                                                        {{ Number(y.amount).toLocaleString() }}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                            <tfoot>
                                                                <tr>
                                                                    <td>الاجمالى</td>
                                                                    <td colspan="2">{{ textamount }}</td>
                                                                    <td>
                                                                        {{ Number(totalamount).toLocaleString() }}
                                                                    </td>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                    <div>
                                                        نأمل منكم التكرم بسداد المبلغ الموضح أعلاه بواسطة
                                                        شيك او حوالة بنكية او اية طريقة ترونها مناسبة علما
                                                        بان معلومات الحساب البنكى كالاتى :
                                                        <br />
                                                        {{ this.$store.state.cnum[0].cname }} <br />
                                                        {{ bankinfo }}
                                                        <br /><br />
                                                        ولكم جزيل الشكر ,,,,,
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                                                    {{ $t("cancel") }}
                                                </button>
                                                <button type="button" class="btn btn-primary" @click="pdf(x.qid)">
                                                    <i class="bi bi-printer-fill"></i> {{ $t("print") }}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import store from "@/store";
import axios from "axios";
import { mapActions } from "vuex";
import html2pdf from "html2pdf.js";
var tafqeet = require("../../TafqeetJs-master/Tafqeet");

export default {
  props: ["css"],
  components: {},
  data() {
    return {
      cnum: store.state.cnum[0].cnum,
      property: [],
      property2: [],
      filters: {
        qid: "",
        propertyname: "",
        rentername: "",
        unite: "",
        conttype: "",
        contduration: ""
      },
      commission: [],
      due: "",
      dueamount: "",
      tax: "",
      unitetype: "",
      unitspace: "",
      protype: "",
      totalamount: "",
      unitspacep: "",
      textamount: "",
      bankinfo: "",
      url: store.state.imgurl + `/clogo/${store.state.cnum[0].cnum}.png`,
      link: "/property/propertypriceofferview/",
    };
  },
  async mounted() {
    await this.applyFilters();
  },
  methods: {
    async applyFilters() {
      try {
        const queryParams = new URLSearchParams();
        if (this.filters.qid) queryParams.append("qid", this.filters.qid);
        if (this.filters.propertyname) queryParams.append("propertyname", this.filters.propertyname);
        if (this.filters.rentername) queryParams.append("rentername", this.filters.rentername);
        if (this.filters.unite) queryParams.append("unite", this.filters.unite);
        if (this.filters.conttype) queryParams.append("conttype", this.filters.conttype);
        if (this.filters.contduration) queryParams.append("contduration", this.filters.contduration);

        const result = await axios.get(`/data/getallpropertypriceoffer?${queryParams.toString()}`);
        if (result.status === 200) {
          this.property = result.data.data[0];
          this.property2 = result.data.data[0];
          this.bankinfo = result.data.data[1][0].bankinfo;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    pdf(qid) {
      const modalContent = document.getElementById(`main-${qid}`).innerHTML;
      html2pdf(modalContent, {
        margin: 0.5,
        filename: `عرض سعر-${qid}.pdf`,
        image: { type: "jpeg", quality: 100 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      });
    },
    fixArabicTextWithNumbers(text) {
      if (!text) return '';
      return text
        .replace(/([أ-ي])(\d)/g, '$1 $2')
        .replace(/(\d)([أ-ي])/g, '$1 $2')
        .replace(/\s{2,}/g, ' ')
        .trim();
    },
    getdata(x) {
      this.commission = JSON.parse(x.commission);
      this.unite = JSON.parse(x.unitedetails);
      this.due = this.unite.due;
      this.unitetype = this.unite.type;
      const amount = (x.contamount / 12) * x.contduration;
      if (x.conttype === "residential") {
        this.dueamount = amount;
        this.tax = 0;
      }
      if (x.conttype === "commercial") {
        const tax = ((amount / 1.15) * 15) / 100;
        this.dueamount = amount - tax;
        this.tax = tax;
      }
      this.unitspace = this.unite.unitspace;
      this.unitspacep = this.unite.unitspacep;
      this.protype = this.unite.protype;
      const totalcommission = this.commission.reduce(
        (acc, array) => acc + Number(array.amount),
        0
      );
      this.totalamount = Number(
        Number(amount) + Number(totalcommission)
      ).toFixed(2);
      var fraction = this.totalamount.split(".");
      if (fraction.length === 2) {
        this.textamount =
          tafqeet.tafqeet(fraction[0]) +
          " " +
          "ريال" +
          " و " +
          tafqeet.tafqeet(fraction[1]) +
          " هلله " +
          " فقط ";
        if (Number(fraction[1]) === 0) {
          this.textamount =
            tafqeet.tafqeet(fraction[0]) + " " + "ريال" + " " + " فقط ";
        }
      }
      if (fraction.length === 1) {
        this.textamount =
          tafqeet.tafqeet(fraction[0]) + " " + "ريال" + " " + "فقط";
      }
    },
    ...mapActions(["redirectTo"]),
  },
};
</script><style lang="scss" scoped>
.page {
    direction: v-bind("css.EN");
    padding: 0.5%;
}

.main {
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    padding: 1%;
}

.body {
    padding: 1%;
    // min-height: 500px;
    // border: 1px solid black;
    // box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.part .group {
    width: 50%;
    //   border: black 1px solid;
}

.part img {
    width: 100%;
    height: 100px;
    //   border: black 1px solid;
}

ul {
    text-decoration: none;
    list-style-type: none;
    color: black;
}

.bi {
    margin: 1%;
}

.head {
    padding: 0.25%;
    display: flex;
    border-bottom-style: ridge;
}

.head1 {
    width: 60%;
}

.head1 input {
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
}

.head2 {
    width: 40%;
    text-align: center;
}

.head2 button {
    margin: 0.5%;
    padding: 1%;
    border: none;
    border-radius: 5px;
    background-color: rgba(98, 153, 174, 255);
    color: white;
    font-size: small;
    width: 30%;
}

.head2 button a {
    color: white;
}

.modhead {
    display: flex;
}

.modhead .part {
    width: 75%;
    padding-top: 5%;
    font-size: large;
}

.modhead .logo {
    width: 15%;
}

.modhead img {
    width: 100%;
}

button {
    margin: 0.5%;
    padding: 1%;
    border: none;
    border-radius: 5px;
    background-color: rgba(98, 153, 174, 255);
    color: white;
    font-size: small;
    width: 25%;
}

.head1 select {
    margin: 0.5%;
    padding: 0.5%;
    border: none;
    border-radius: 5px;
    background-color: #eee;
}
</style>
